import { Env } from '../helpers/infra.esm.js';

function getTldPerEnv(env) {
    switch(env){
        case Env.Production:
            return "lemonade.com";
        case Env.Staging:
            return "lmndstaging.com";
        case Env.Sandbox:
            return "lmndsandbox.com";
        case Env.Development:
            return "lmnddev.com";
        default:
            return "";
    }
}

export { getTldPerEnv };
